import React, { useState } from "react";
import { PlaylistAction } from "../playlistReducer";
import { defineMessages, useIntl } from "react-intl";
import { playlistMessages } from "../playlistMessages";
import ContainerBlock from "../../../Components/ContainerBlock/ContainerBlock";
import ReorderableList from "../../../../../../components/ReorderableList/ReorderableList";
import { Item, Selection } from "react-stately";
import { TeacherResourceMiniature } from "../../../../../../design-system-components/ResourceMiniature";
import useResourceURL from "../useResourceURL";
import { getInitialActiveNodeFromURL } from "../utils";
import { useParams } from "react-router-dom";
import { CreateURLParams } from "../../const";
import { ResourcePath } from "../../utils";

import "./TeacherPlaylistOrganize.scss";

type Props = {
    resources: ResourcePath[];
    dispatch: React.Dispatch<PlaylistAction>;
};

const TeacherPlaylistOrganize = ({ resources, dispatch }: Props) => {
    const intl = useIntl();
    const { goToResourceURL } = useResourceURL();
    const urlParams = useParams<CreateURLParams>();

    const [activeResource, setActiveResource] = useState<Selection>(
        new Set(
            [getInitialActiveNodeFromURL(urlParams)].filter(
                (key) => !!key
            ) as string[]
        )
    );

    if (resources.length === 0) return <EmptyState />;

    return (
        <ContainerBlock className="playlist-resources-reorder__container">
            <h3 id="playlist-resources-reorder">
                {resources.length}{" "}
                {intl.formatMessage(playlistMessages.resources)}
            </h3>

            <ReorderableList
                aria-labelledby="playlist-resources-reorder"
                className="playlist-resources__resources-list"
                classNames={{
                    dragging: "playlist-resources__item--dragging",
                }}
                initialItems={resources}
                selectedKeys={activeResource}
                onSelectionChange={(key) => setActiveResource(key)}
                onReorder={(newOrder) => {
                    dispatch({
                        type: "change_resources_order",
                        resources: newOrder,
                    });
                }}
                accentColor="var(--element-teacher-default)"
            >
                {(item) => (
                    <Item textValue="toto">
                        <TeacherResourceMiniature
                            path={item}
                            className="teacher-playlist-organize__miniature"
                            onClick={() => {
                                goToResourceURL(item.toEditorPath());
                            }}
                            draggable
                        />
                    </Item>
                )}
            </ReorderableList>
        </ContainerBlock>
    );
};
export default TeacherPlaylistOrganize;

const messages = defineMessages({
    selectResourcesBeforeReorder: {
        id: "playlist-select-resources-to-organize",
        defaultMessage:
            "Select items from the resources list in the 'Select' tab before reorganizing them here.",
    },
});

const EmptyState = () => {
    const intl = useIntl();

    return (
        <ContainerBlock>
            <h3>
                {"0 "}
                {intl.formatMessage(playlistMessages.resources)}
            </h3>
            <p>{intl.formatMessage(messages.selectResourcesBeforeReorder)}</p>
        </ContainerBlock>
    );
};
